import {
  ADMISSION_STATUS_ORDER,
  readableAdmissionStatus,
} from "../../../atoms/admission-status-tag";
import {Status} from "./types";

export const STATUSES: ReadonlyArray<Status> = [
  {id: null, label: "All"},
  ...ADMISSION_STATUS_ORDER.map(status => ({
    id: status,
    label: readableAdmissionStatus(status),
  })),
];

export const LIST_VIEW_KEY = "list-view";
export const TILE_VIEW_KEY = "tile-view";

/**
 * All possible view keys.
 */
export const VIEW_KEYS = [LIST_VIEW_KEY, TILE_VIEW_KEY];

/**
 * Class name for the active view used to manage styles.
 */
export const ACTIVE_VIEW_CLASS = "active-view";
